var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPorCobrarBalken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efb928;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7590",
    className: "cls-1",
    d: "M13,0C5.82,0,0,5.82,0,13s5.82,13,13,13,13-5.82,13-13S20.18,0,13,0ZM13,23.4c-5.74,0-10.4-4.66-10.4-10.4S7.26,2.6,13,2.6s10.4,4.66,10.4,10.4-4.66,10.4-10.4,10.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7591",
    className: "cls-1",
    d: "M12.8,5.6c-.66,0-1.2.54-1.2,1.2v5.51l-3.25,3.24c-.5.43-.56,1.19-.13,1.69.43.5,1.19.56,1.69.13.05-.04.09-.08.13-.13l3.6-3.6c.23-.22.36-.52.36-.84v-6c0-.66-.54-1.2-1.2-1.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorCobrarBalken);
export default __webpack_public_path__ + "static/media/por-cobrar_BALKEN.301467c707b5b7499c9ef416fb656271.svg";
export { ForwardRef as ReactComponent };